import { Component } from '@angular/core';

@Component({
  templateUrl: './executive-terms.component.html',
  styleUrls: ['./executive-terms.component.css']
})
export class ExecutiveTermsComponent {}
